import { useContext } from "react"
import { motion } from "motion/react"

import { AppContext } from "../App"
import { LetterStatus } from "../helpers"

type Props = {
  keyVal: string
  bigKey?: boolean
  status?: LetterStatus
}

function Key({ keyVal, bigKey = false, status = LetterStatus.Unknown }: Props) {
  const { onDelete, onEnter, onSelectLetter } = useContext(AppContext)

  const selectLetter = () => {
    if (keyVal === "DELETE") {
      onDelete()
      return
    }

    if (keyVal === "ENTER") {
      onEnter()
      return
    }

    onSelectLetter(keyVal)
  }

  let letterState = ""
  switch (status) {
    case LetterStatus.Letter:
      letterState = "almost"
      break
    case LetterStatus.LetterAndPosition:
      letterState = "correct"
      break
    case LetterStatus.Disabled:
      letterState = "error"
      break
    default:
      break
  }

  const label = keyVal === "DELETE" ? "⌫" : keyVal === "ENTER" ? "Enter" : keyVal

  return (
    <motion.button
      type="button"
      className={`key ${bigKey ? "key-big" : ""} ${letterState}`.trim()}
      onClick={selectLetter}
      whileHover={{ y: -2, filter: "brightness(1.08)" }}
      whileTap={{ scale: 0.96 }}
      transition={{ duration: 0.16 }}
      aria-label={keyVal}
    >
      {label}
    </motion.button>
  )
}

export default Key
